module.exports = __webpack_public_path__ + "static/media/arrow-right.14f38f98.svg";